import {
  useNavigate,
} from 'react-router-dom';

import {
  ROUTES,
} from '../../../config/routes';

import useLoginForm
  from '../hooks/useLoginForm';

import LoginForm
  from './LoginForm';

import '../login/LoginPage.css';

import './LoginSection.css';

export default function LoginSection({
  loginAction,
  onLoginSuccess,
  variant = 'inline',
}) {
  const navigate =
    useNavigate();

  const {
    form,
    showPassword,
    error,
    isSubmitting,
    handleInputChange,
    handleSubmit,
    togglePasswordVisibility,
  } = useLoginForm({
    loginAction,
    onSuccess:
      onLoginSuccess,
  });

  const handleNavigate = (
    path,
  ) => {
    const isSafeInternalPath =
      typeof path ===
        'string' &&
      path.startsWith(
        '/',
      ) &&
      !path.startsWith(
        '//',
      );

    if (
      !isSafeInternalPath
    ) {
      return;
    }

    navigate(
      path,
    );
  };

  return (
    <section
      className={[
        'login-section',
        `login-section--${variant}`,
      ].join(' ')}
    >
      <div
        className="login-container"
      >
        <LoginForm
          form={
            form
          }
          showPassword={
            showPassword
          }
          error={
            error
          }
          isSubmitting={
            isSubmitting
          }
          onInputChange={
            handleInputChange
          }
          onSubmit={
            handleSubmit
          }
          onTogglePassword={
            togglePasswordVisibility
          }
          onFindAccount={() =>
            handleNavigate(
              ROUTES.findAccount,
            )
          }
          onSignup={() =>
            handleNavigate(
              ROUTES.signup,
            )
          }
        />
      </div>
    </section>
  );
}